import { Map } from '@emotion-icons/boxicons-solid/Map'
import styled from '@emotion/styled'
import { Link, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import { useMemo, useState } from 'react'
import { BASE_IMAGE_URL } from 'src/common-services/types/brand-logo-types'
import { LogoAvatar } from 'src/components/logo-avatars'
import { SearchableModal } from 'src/components/searchable-modal'
import { Colors, Shapes } from 'src/components/theme'
import FREE_LOCATIONS from 'src/constants/free-locations.json'

const LocationWrapper = styled(Link)`
  display: flex;
  align-items: center;
  padding: ${Shapes.spacing[3]}px ${Shapes.spacing[2]}px;
  justify-content: space-between;
  border-radius: ${Shapes.borderRadius}px;
  text-decoration: none;
  :hover {
    background-color: ${Colors.neutral50};
    cursor: pointer;
  }
`
const LocationLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`

type LocationItemProps = {
  location: any
}
const LocationItem = (props: LocationItemProps) => {
  const { location } = props
  const router = useRouter()

  const url = useMemo(() => {
    let route = router.asPath.split('?')[0]
    if (route.includes('no-rank') && location.hasRank) {
      // replace with rank
      route = route.replace('no-rank', 'rank')
    }
    return `${route}?lid=${location.locationId}&pid=${location.placeId}`
  }, [router.asPath, location])

  return (
    <LocationWrapper target="_blank" href={url}>
      <LocationLabel>
        <LogoAvatar size={24} url={location.logo ? `${BASE_IMAGE_URL}${location.logo}` : null} alt={location.name} />
        <Typography variant="textmdm" color={Colors.textMedium}>
          {location.name}
        </Typography>
      </LocationLabel>
      <Typography variant="textmdm" color={Colors.textLight}>
        {location.address}
      </Typography>
    </LocationWrapper>
  )
}

type FreeLocationsModalProps = {
  open: boolean
  onClose: () => void
}
export const FreeLocationsModal = (props: FreeLocationsModalProps) => {
  const { open, onClose } = props
  const [search, setSearch] = useState('')

  const locations = useMemo(() => {
    return FREE_LOCATIONS.filter((location) => {
      if (search === '') {
        return location
      } else if (
        location.name.toLowerCase().includes(search.toLowerCase()) ||
        location.address.toLowerCase().includes(search.toLowerCase())
      ) {
        return location
      }
    })
  }, [FREE_LOCATIONS, search])

  return (
    <SearchableModal
      open={open}
      onClose={onClose}
      titleIcon={<Map size={20} color={Colors.textWhite} />}
      title="Free Sample Locations"
      subtitle="View in a Sample Location"
      variant="primary"
      onFilterChange={setSearch}>
      {locations.map((location) => (
        <LocationItem key={'sample-location-' + location.locationId} location={location} />
      ))}
    </SearchableModal>
  )
}
